import React, { useEffect, useState } from 'react';
import './login.css'
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import { MdOutlineLock } from 'react-icons/md';
import * as Yup from 'yup';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import { FaCircleUser } from 'react-icons/fa6';
import logo from '../assests/download.png'
const Login = ({ toggleForm }) => {
    const navigate = useNavigate();
    const [type, setType] = useState('password');
    const [icon, setIcon] = useState(<FiEyeOff style={{ color: "#8B8B8B", fontSize: "1.2rem", cursor: "pointer" }} />);
    // const validationLogin = Yup.object().shape({
    //     user_id: Yup.string().trim().required('User Id is Required'),
    //     password: Yup.string().trim().required('Password is Required'),
    // });

    const formik = useFormik({
        initialValues: {
            user_id: "",
            password: "",
        },
        // validationSchema: validationLogin,
        onSubmit: async (values) => {
            const trimmedValues = {
                user_id: values.user_id.trim(),
                password: values.password.trim(),
            };

            const url = `${process.env.REACT_APP_BASE_URL}/login`;
            try {
                const res = await (await fetch(url, {
                    method: 'POST',
                    headers: {
                        "content-type": 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    },
                    body: JSON.stringify(trimmedValues)
                })).json();

                if (res?.status !== true || !res?.token) {
                    Swal.fire({
                        icon: 'error',
                        text: res.msg,
                        toast: true,
                        position: 'top',
                        background: "red",
                        color: "white",
                        showConfirmButton: false,
                        timer: 2000,
                        width: 450,
                        padding: ".5rem"
                    });
                } else {
                    const expirationTime = new Date().getTime() + 60 * 60 * 1000;
                    localStorage.setItem('token', res.token);
                    localStorage.setItem('role', res.role);
                    localStorage.setItem('expiryTime', expirationTime);

                    // Navigate to reports page after successful login
                    navigate("/meetings");
                }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    text: 'Something went wrong. Please try again later.',
                    toast: true,
                    position: 'top',
                    background: "red",
                    color: "white",
                    showConfirmButton: false,
                    timer: 2000,
                    width: 450,
                    padding: ".5rem"
                });
            }
        }
    });


    const handleToggle = () => {
        if (type === 'password') {
            setIcon(<FiEye style={{ color: "#8B8B8B", fontSize: "1.5rem", cursor: "pointer" }} />);
            setType('text');
        } else {
            setIcon(<FiEyeOff style={{ color: "#8B8B8B", fontSize: "1.5rem", cursor: "pointer" }} />);
            setType('password');
        }
    };
    useEffect(() => {
        if (localStorage.getItem('token')) {

            navigate("/meetings");
        }
    }, [navigate]);
    return (
        <div className="login-container">
            <div className="login-form-container">
                <div className="main-input-container">
                    <div className="sign-in-content">
                        <img src={logo} alt="Logo" className="logo" />
                    </div>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="input-container">
                            <FaCircleUser className="input-icon" />
                            <input
                                type="text"
                                name="user_id"
                                id="userId"
                                placeholder="User ID"
                                autoComplete="off"
                                onChange={formik.handleChange}
                                value={formik.values.user_id}
                                onBlur={formik.handleBlur}
                            />
                        </div>
                        {formik.errors.user_id && formik.touched.user_id && (
                            <span className="error">{formik.errors.user_id}</span>
                        )}
                        <div className="input-container">
                            <MdOutlineLock className="input-icon" />
                            <input
                                type={type}
                                name="password"
                                autoComplete="off"
                                placeholder="Password"
                                id="password"
                                onChange={formik.handleChange}
                                value={formik.values.password}
                                onBlur={formik.handleBlur}
                            />
                            <span onClick={handleToggle} className="toggle-icon">
                                {icon}
                            </span>
                        </div>
                        {formik.errors.password && formik.touched.password && (
                            <span className="error">{formik.errors.password}</span>
                        )}
                        <button type="submit" className="login-btn">Login</button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Login;
